/* eslint-disable max-len */
import { LiteracyScreeningDiagnosticMeasuresFormValues } from './Validation/LiteracyScreeningDiagnosticMeasuresValidationSchema';
import { LiteracyScreeningReimbursementFormValues } from './Validation/LiteracyScreeningReimbursementValidationSchema';

export interface LiteracyScreeningDiagnosticMeasuresModel {
  id: string;
  schoolYear: string;
  leaIdentifier: string;
  reimbursement: string;
  explanation: string;
  phonemicAwareness: string[];
  phonics: string[];
  vocabulary: string[];
  oralLanguage: string[];
  updatedBy: string;
  updatedDateTime: string;
}

export const LITERACY_SCREENING_DIAGNOSTIC_OPTION_SETS = {
  phonemicAwareness: 'PhonemicAwarenessOptions',
  phonics: 'PhonicOptions',
  vocabulary: 'VocabularyOptions',
  oralLanguage: 'OralLanguageOptions',
} as const;

export const LITERACY_SCREENING_COMMON_OPTION_SETS = {
  yesNo: 'yesNoOptions',
} as const;

export const initialLiteracyScreeningDiagnosticMeasures: LiteracyScreeningDiagnosticMeasuresModel =
  {
    id: '',
    schoolYear: '',
    leaIdentifier: '',
    reimbursement: '',
    explanation: '',
    phonemicAwareness: [],
    phonics: [],
    vocabulary: [],
    oralLanguage: [],
    updatedBy: '',
    updatedDateTime: '',
  };

export const isNewLiteracyScreeningDiagnosticsId = (id?: string): boolean =>
  !id || id.trim() === '';

export const buildLiteracyScreeningDiagnosticsSaveModel = (
  existing: LiteracyScreeningDiagnosticMeasuresModel | null,
  schoolYear: string,
  leaIdentifier: string,
  diagnostics: LiteracyScreeningDiagnosticMeasuresFormValues,
  reimbursement: LiteracyScreeningReimbursementFormValues
): LiteracyScreeningDiagnosticMeasuresModel => ({
  id: existing?.id || '',
  schoolYear: schoolYear || existing?.schoolYear || '',
  leaIdentifier: leaIdentifier || existing?.leaIdentifier || '',
  reimbursement: reimbursement.reimbursement || '',
  explanation: reimbursement.explanation || '',
  phonemicAwareness: diagnostics.phonemicAwareness || [],
  phonics: diagnostics.phonics || [],
  vocabulary: diagnostics.vocabulary || [],
  oralLanguage: diagnostics.oralLanguage || [],
  updatedBy: existing?.updatedBy || '',
  updatedDateTime: existing?.updatedDateTime || '',
});
